import styled from "styled-components";
import React, {useContext} from "react";
import {TableInstanceContext} from "../EnvResultsTable";
import {Pagination} from "./Pagination";

const Wrapper = styled.div`
  display: flex;
  padding: 10px;
  align-items: center;
`


const PaginationWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
`

export const TopBar = () => {
    const {tableInstance} = useContext(TableInstanceContext);
    const {data} = tableInstance;
    const total = data.length;
    return (
        <Wrapper>
            <div>
                <strong>{total}</strong> Results
            </div>
            <PaginationWrapper>
                <Pagination/>
            </PaginationWrapper>
        </Wrapper>
    );
};
